import { render, staticRenderFns } from "./company_info.vue?vue&type=template&id=ebc62900&scoped=true"
import script from "./company_info.vue?vue&type=script&lang=js"
export * from "./company_info.vue?vue&type=script&lang=js"
import style0 from "./company_info.vue?vue&type=style&index=0&id=ebc62900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc62900",
  null
  
)

export default component.exports